import styled from "styled-components";
import React from "react";
import * as api from '../../api';
import H2 from "../Atoms/H2";
import { useTranslation } from 'react-i18next';
import Input from "../Atoms/Input";
import Select from "../Atoms/Select";
import CheckboxPublicPrivate from "../Atoms/CheckboxPublicPrivate";
import H1 from "../Atoms/H1";
import Textarea from "../Atoms/Textarea";
import ImageUpload from "../Atoms/ImageUpload";
import Popup from "../Atoms/Popup";
import { useNavigate, useLocation } from "react-router-dom";
import CompanySelect from "../Components/CompanySelector";
import Spinner from "../../Plateforme/Atoms/Spinner";
import { NeedToPay, cat_gories_viaContainsVIACategory, validateFrom } from "../Utils/Validator";
import PaymentPopup, { PaymentPopupV2 } from "../Components/PaymentPopup";
import Section from "../Atoms/Section";
import BlueButton from "../Atoms/BlueButton";
import SocialNetworks from "../Atoms/SocialNetworks";
import { CountrySelectOptions } from "../Utils/Listings";
import DefaultCompanyCover from "../Utils/DefaultCompanyCover";
import EditLangues from "../Atoms/EditLangues";
import PopupGoToSDE24 from "../Components/SDE24/PopupGoToSDE24";
import { dateFrontTodateHs, dateHsTodateFront } from "../Utils/Format";
import UploadProgressBar from "../Atoms/UploadProgressBar";
import H0 from "../Atoms/H0";
import BoldBlue from "../Atoms/BoldBlue";
import { getStoredRedirect, clearStoredRedirect, createUrlWithRedirect } from "../Utils/redirectUtils";
import toast from 'react-hot-toast';

const MyProfile = (props) => {

    const [user, setUser] = React.useState(props.fullUser);
    const [popupOpen, setPopupOpen] = React.useState(false);
    const [companyPopupOpen, setCompanyPopupOpen] = React.useState(false);
    const [PaymentPopupOpen, setPaymentPopupOpen] = React.useState(false);
    const [eventPopupOpen, setEventPopupOpen] = React.useState(false);
    const [deleteAccountPopupOpen, setDeleteAccountPopupOpen] = React.useState(false);
    const [selectedCollaborator, setSelectedCollaborator] =  React.useState(null); //for the delete account popup
    const [collaborators, setCollaborators] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [cvInputValue, setCvInputValue] = React.useState('');
    const [removeCvInDB, setRemoveCvInDB] = React.useState(false);
    const [uploadProgress, setUploadProgress] = React.useState(0);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const location = useLocation();
    const cvInputRef = React.useRef(null);
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    React.useEffect(() => {
        if(props.fullUserLoading) return;
        if(!props.fullUser?.user) navigate(createUrlWithRedirect('/login', location.pathname + location.search));
        if(props.fullUser?.user && props.fullUser.user.role === "admin" && id){
            getProfile()
        }else{
            setUser(props.fullUser);
        }
    }, [props.fullUserLoading, props.fullUser, id]);

    React.useEffect(() => {
        setSelectedCollaborator(null); // Set selectedCollaborator to null when the popup changes state
    }, [deleteAccountPopupOpen]);

    React.useEffect(() => {
        if(!user?.company?._id) return;
        api.GetCollaborators({hubspotID : user?.company.hubspotID}).then((response) => {
            setCollaborators(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }, [user?.company]);

    function logout() {
        console.log("logout")
        api.Logout().then(() => {
            props.refreshUser();
            navigate('/annuaire');
        }).catch((error) => {
            console.log(error);
        });
    }

    function deleteAccount(e){
        e.preventDefault();
        if(!window.confirm(i18n.language === "fr" ? "Êtes-vous sûr ? Cette action est irréversible." : "Are you sure? This action is irreversible.")) return;

        const userIdToDelete = user.user._id;
        api.DeleteAccount({userIdToDelete, selectedCollaborator}).then(() => {
            console.log("account deleted");
            if(id){
                navigate('/admin/profiles');
            }else{
                logout()
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    function getProfile(){
        api.GetAllUserData({email : atob(id)}).then((response) => {
            setUser(response.data);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        })
    }

    if(loading || props.fullUserLoading || !user){
        return (
            <>
                <br/><br/><br/>
                <Spinner/>
                <br/>
                <UploadProgressBar uploadProgress={uploadProgress}/>
            </>
        )
    }

    const setFirstName = (e) => {
        setUser({...user, hsProfile:{...user.hsProfile, firstname:e.target.value}});
    }

    const setLastName = (e) => {
        setUser({...user, hsProfile:{...user.hsProfile, lastname:e.target.value}});
    }

    function viewInPublicMode(event){
        event.preventDefault();
        navigate('/profile?id=' + btoa(user.user.email));
    }

    function onUploadProgress(progressEvent){
        const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        setUploadProgress(percentCompleted);
    }

    async function handleSubmit(event, formElement) {
        event.preventDefault();
        const submission = new FormData(formElement || event.target);
        const date_of_birth = submission.get('date_of_birth');
        if(date_of_birth){
            const date_new_format = dateFrontTodateHs(date_of_birth)
            submission.set('date_of_birth', date_new_format);
        }
        if(!validateFrom(submission)) return;
        setLoading(true);
        submission.append('userid', user.user._id);
        if(removeCvInDB){
            submission.append('requestRemoveCV', "true");
        }
        // Debug: log key fields being sent
        console.log('[MyProfile] Saving profile — jobtitle:', submission.get('jobtitle'), 'city:', submission.get('city'), 'firstname:', submission.get('firstname'));
        api.UpdateProfile(submission, onUploadProgress).then((response) => {
            console.log('[MyProfile] Server response:', response.data);
            if(response.data === "file too big"){
                setLoading(false);
                alert(i18n.language === "fr" ? "Le fichier est trop volumineux." : "The file is too big.");
            }
            if(response.data === "go to company"){
                if(id){
                    getProfile()
                    toast.success(i18n.language === 'fr' ? 'Profil enregistré' : 'Profile saved');
                    setTimeout(() => navigate('/annuaire'), 3000);
                }else{
                    // Await refreshUser so the form remounts with updated data
                    props.refreshUser().then((updatedUser) => {
                        if (updatedUser) setUser(updatedUser);
                        setLoading(false);
                        setCompanyPopupOpen(true);
                    }).catch((err) => {
                        console.error("refreshUser error:", err);
                        setLoading(false);
                        setCompanyPopupOpen(true);
                    });
                }
            }
            if(response.data === "ok"){
                if(id){
                    getProfile()
                    toast.success(i18n.language === 'fr' ? 'Profil enregistré' : 'Profile saved');
                }else{
                    props.refreshUser().then((updatedUser) => {
                        // Update local state with fresh data so form remounts correctly
                        if (updatedUser) setUser(updatedUser);
                        setLoading(false);

                        // Check for stored redirect after successful profile update
                        const storedRedirect = getStoredRedirect();
                        if (storedRedirect && updatedUser?.company?._id) {
                            clearStoredRedirect();
                            navigate(storedRedirect);
                        } else {
                            toast.success(i18n.language === 'fr' ? 'Profil enregistré' : 'Profile saved');
                        }
                    }).catch((err) => {
                        console.error('[MyProfile] refreshUser error after save:', err);
                        setLoading(false);
                        toast.success(i18n.language === 'fr' ? 'Profil enregistré' : 'Profile saved');
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            alert(i18n.language === "fr" ? "Une erreur est survenue lors de la sauvegarde. Veuillez réessayer." : "An error occurred while saving. Please try again.");
        })
    }

    function companyPopupContinue(event) {
        event.preventDefault();
        // console.log("event.target.form");
        // console.log(event.target.form);
        // console.log("create company");
        // console.log(event.target.form.companyhsid_inpopup.value);
        if(!event.target.form.companyhsid_inpopup.value){
            navigate('/mycompany');
        }else{
            setCompanyPopupOpen(false);
            handleSubmit(event, event.target.form);
        }
    }

    const currentCVPath = (cvInputValue && URL.createObjectURL(cvInputValue)) || (user.user?.cv && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user?.cv)) || '';

    function removeCV(){
        setCvInputValue('');
        setUser({...user, user:{...user.user, cv:''}});
        setRemoveCvInDB(true);
        cvInputRef.current.value = '';
    }

    const currentCoverPath = (user.user?.cover && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user.cover)) || (user.company?.cover_picture && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.company.cover_picture)) || '';
    const userIsCompanyOwner = user?.company?.ownerUserId === user?.user?._id;

    return (
        <form onSubmit={event => handleSubmit(event)}>
            <Section>
                <ImageUpload
                    currentImagePath={currentCoverPath}
                    creditFieldDefaultValue={user.user?.creditcover}
                    textFR="une photo de couverture"
                    textEN="a cover picture"
                    name="coverpicture"
                    creditFieldName="creditcover"
                    width="100%"
                    height="400px"
                />
            </Section>
            <Section className="padding flexblock" style={{alignItems:'center'}}>
                <H0 style={{cursor:'pointer', textTransform:'uppercase'}} onClick={() => setPopupOpen(true)}>{user.hsProfile?.firstname} {user.hsProfile?.lastname}</H0>
                <input name="firstname" hidden readOnly value={user.hsProfile?.firstname || ''}/>
                <input name="lastname" hidden readOnly value={user.hsProfile?.lastname || ''}/>
             
                {cat_gories_viaContainsVIACategory(user.hsProfile?.cat_gories_via) && 
                    <BoldBlue onClick={event => viewInPublicMode(event)} style={{display:"inline-block", cursor:'pointer'}}>
                        <img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{i18n.language === "fr" ? "Voir en mode public" : "View in public mode"}
                    </BoldBlue>
                }
            </Section>
            {popupOpen && <Popup close={() => setPopupOpen(false)}>
                <div style={{width:"100%"}} >{i18n.language === "fr" ? "Prénom" : "First name"}*</div>
                <Input style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Prénom" : "First name"} defaultValue={user.hsProfile?.firstname} onChange={e => setFirstName(e)}/><br/>
                <div style={{width:"100%"}} >{i18n.language === "fr" ? "Nom" : "Last name"}*</div>
                <Input style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Nom" : "Last name"} defaultValue={user.hsProfile?.lastname} onChange={e => setLastName(e)}/><br/>
                <BlueButton onClick={(event) => {event.preventDefault(); setPopupOpen(false)}}>{i18n.language === 'fr' ? 'Valider' : 'Done'}</BlueButton>
            </Popup>}
            <Section className="flexblock">
                <div>
                    <br/>
                    <H2>{i18n.language === "fr" ? "Votre profil" : "Your profile"}</H2><br/><br/>
                    <Input name="jobtitle" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Poste actuel" : "Current position"}  defaultValue={user.hsProfile?.jobtitle}/><br/><br/>
                    <CompanySelect name="companyhsid" selectedCompany={user.hsCompany} readOnly={user.user?.companyHubspotID}/><br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Années d'experience" : "Years of experience"}</span>
                        <Input type="number" name="yearsofexperience" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Année d'experiences" : "Years of experience"}  defaultValue={user.hsProfile?.seniority}/>
                    </div><br/>
                    <div className="flexblock">
                        <Input name="city" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Ville" : "City"} defaultValue={user.hsProfile?.city}/>
                        <Select name="country" placeholder={i18n.language === "fr" ? "Pays" : "Country"}  style={{width:"100%"}} defaultValue={user.hsProfile?.country}>
                            <CountrySelectOptions/>
                        </Select>
                    </div><br/>
                    <Input name="school" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "École" : "School"}  defaultValue={user.hsProfile?.school}/><br/>
                </div>
                <div>
                    <br/>
                    <H2>{i18n.language === "fr" ? "Contact et réseaux" : "Contact and networks"}</H2><br/><br/>
                    <Input style={{width:"calc(100% - 115px)"}} readOnly placeholder={i18n.language === "fr" ? "Email" : "Email"} defaultValue={user.hsProfile?.email}/><CheckboxPublicPrivate name="showmail" defaultChecked={user.user?.showmail}/><br/><br/>
                    <Input name="mobilephone" style={{width:"calc(100% - 115px)"}} placeholder={i18n.language === "fr" ? "Téléphone portable" : "Mobile phone"}  defaultValue={user.hsProfile?.mobilephone}/><CheckboxPublicPrivate name="showmobilephone" defaultChecked={user.user?.showmobilephone}/><br/><br/>
                    <Input name="phone" style={{width:"calc(100% - 115px)"}} placeholder={i18n.language === "fr" ? "Téléphone fixe" : "Landline"}  defaultValue={user.hsProfile?.phone}/><CheckboxPublicPrivate name="showphone" defaultChecked={user.user?.showphone}/><br/><br/>
                    <SocialNetworks
                        twitter={user.hsProfile?.twitterhandle}
                        instagram={user.hsProfile?.instagram_account}
                        linkedin={user.hsProfile?.lien_linkedin}
                    /><br/>
                </div>
            </Section>
            <Section className="flexblock">
                <div>
                    <br/>
                    <ImageUpload
                        currentImagePath={user.user?.portrait && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user?.portrait)}
                        creditFieldDefaultValue={user.user?.creditphoto}
                        textFR="une photo de profil"
                        textEN="a profile picture"
                        name="profilepicture"
                        creditFieldName="creditphoto"
                        width="400px"
                        height="400px"
                    />
                    <br/>
                </div>
                <div style={{flex : "2"}}>
                    <br/>
                    <H2>{i18n.language === "fr" ? "Informations complémentaires" : "Additional information"}</H2><br/><br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Date de naissance" : "Date of birth"} <i style={{fontSize:'12px'}}>{i18n.language === "fr" ? "(JJ-MM-AAAA)" : "(DD-MM-YYYY)"} </i></span>
                        <span style={{minWidth:'300px'}}>
                            <Input name="date_of_birth" style={{}} placeholder={i18n.language === "fr" ? "JJ-MM-AAAA" : "DD-MM-YYY"} defaultValue={dateHsTodateFront(user.hsProfile?.date_of_birth)}/>
                            <CheckboxPublicPrivate name="showdate_of_birth" defaultChecked={user.user?.showdate_of_birth}/>
                        </span>
                    </div>
                    <div className="flexblock" style={{marginBottom:"20px"}}>
                        <span>{i18n.language === "fr" ? "Nationalité" : "Nationality"}</span><Input name="nationality" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Nationalité" : "Nationality"}  defaultValue={user.hsProfile?.nationalite}/>
                    </div>
                    {/* <div className="flexblock"><span>{i18n.language === "fr" ? "Langues" : "Languages"}</span><Input name="languages" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Langues" : "Languages"}  defaultValue={user.hsProfile?.languages}/></div> */}
                    <EditLangues style={{width:"100%"}} name="langues" defaultValue={user.hsProfile?.langues}/><br/>
                    <br/>
                </div>
            </Section>
            <Section className="padding">
                <br/>
                <H2>{i18n.language === "fr" ? "À propos" : "About"}</H2><br/><br/>
                <BlueButton onClick={(e) => {e.preventDefault(); cvInputRef.current?.click()}}><img src='/img/import.png' alt=''/>{i18n.language === "fr" ? "Importer votre CV" : "Import your resume"}</BlueButton>{currentCVPath && <ExistingCV path={currentCVPath} removeCV={removeCV}/>}<br/><br/>
                <input hidden name="cv" ref={cvInputRef} onChange={e => setCvInputValue(e.target.files[0])} style={{width:"100%"}} type="file" accept="application/pdf"/><br/><br/>
                <span>{i18n.language === "fr" ? "Français" : "French"}</span><br/>
                <Textarea name="aboutfr" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "À propos de vous" : "About you"}  defaultValue={user.hsProfile?.presentation_libre_fr}/><br/><br/>
                <span>{i18n.language === "fr" ? "Anglais" : "English"}</span><br/>
                <Textarea name="abouten" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "À propos de vous" : "About you"}  defaultValue={user.hsProfile?.presentation_libre_en}/><br/><br/>
            </Section>
            <Section className="padding">
                <BlueButton className="centered"><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Enregistrer" : "Save"}</BlueButton>
            </Section>
            <Section className="padding">
                <BlueButton onClick={(e) =>{e.preventDefault(); setDeleteAccountPopupOpen(true)}} className="centered" style={{backgroundColor:'red', color:"white"}}>{i18n.language === "fr" ? "Supprimer mon compte" : "Delete my account"}</BlueButton>
            </Section>
            {companyPopupOpen && <Popup>
                <CompanySelect name="companyhsid_inpopup"/><br/>
                <strong className="centered">{i18n.language === "fr" ? "Si vous ne trouvez pas votre société dans la liste, vous pouvez la créer maintenant en cliquant sur continuer." : "If you can't find your company in the list, you can create it now by clicking continue."}</strong><br/><br/>
                <BlueButton onClick={companyPopupContinue}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Continuer" : "Continue"}</BlueButton>
            </Popup>}
            {PaymentPopupOpen && <PaymentPopupV2 close={() => setPaymentPopupOpen(false)} email={user.hsProfile.email}/>}
            {deleteAccountPopupOpen && <Popup close={() => setDeleteAccountPopupOpen(false)}>
                <H2>{i18n.language === "fr" ? "Suppression du compte" : "Delete account"}</H2><br/>
                {!userIsCompanyOwner && <>
                    <p>{i18n.language === "fr" ? "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible." : "Are you sure you want to delete your account? This action is irreversible."}</p><br/>
                    <BlueButton onClick={deleteAccount}>{i18n.language === "fr" ? "Supprimer mon compte" : "Delete my account"}</BlueButton>
                </>}
                {userIsCompanyOwner && <>
                    <p>{i18n.language === "fr" ? "Vous êtes le responsable de la société " : "You are the owner of the company "}<b>{user?.hsCompany?.properties?.name}</b>{i18n.language === "fr" ? ". Pour garder votre société sur la plateforme, vous devez d'abord transférer la responsabilité de la société à un autre collaborateur." : ". To keep your company on the platform, you must first transfer the ownership of the company to another partner."}</p><br/>
                    <Select style={{width:"100%"}} onChange={e => setSelectedCollaborator(collaborators.find(collab => collab.user._id === e.target.value))}>
                        <option value="">{i18n.language === "fr" ? "Choisir un collaborateur" : "Choose a partner"}</option>
                        {collaborators.filter(collab => collab.user._id !== user.user._id).map((collaborator) => {
                            return <option key={collaborator.user._id} value={collaborator.user._id}>{collaborator.hsProfile.properties.firstname} {collaborator.hsProfile.properties.lastname}</option>
                        })}
                    </Select><br/>
                    {!selectedCollaborator && <strong>{i18n.language === "fr" ? "Aucun collaborateur sélectionné pour le transfert. Si vous supprimez votre compte, votre société ainsi que tous les collaborateurs seront supprimés de la plateforme." : "No partner selected for the transfer. If you delete your account, your company and all partners will be deleted from the platform."}</strong>}<br/>
                    {!selectedCollaborator && <BlueButton onClick={deleteAccount}>{i18n.language === "fr" ? "Supprimer mon compte, la société " + user?.hsCompany?.properties?.name + " et tous les collaborateurs" : "Delete my account, the company " + user?.hsCompany?.properties?.name + " and all partners"}</BlueButton>}
                    {selectedCollaborator && <BlueButton onClick={deleteAccount}>{i18n.language === "fr" ? "Transférer la responsabilité de la société " + user?.hsCompany?.properties?.name + " à " + selectedCollaborator?.hsProfile?.properties?.firstname + " " + selectedCollaborator?.hsProfile?.properties?.lastname + " et supprimer mon compte" : "Transfer the ownership of the company " + user?.hsCompany?.properties?.name + " to " + selectedCollaborator?.hsProfile?.properties?.firstname + " " + selectedCollaborator?.hsProfile?.properties?.lastname + " and delete my account"}</BlueButton>}
                </>}
            </Popup>}
            {eventPopupOpen && <PopupGoToSDE24 close={() => setEventPopupOpen(false)}/>}
        </form>
    );
};

const ExistingCVContainer = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    margin-left: 20px;

    a {
        text-decoration: none;
        color: #777;
        font-size: 14px;
    }
`;

const ExistingCV = (props) => {

    const { i18n } = useTranslation('common');

    return (
        <ExistingCVContainer>
            <a href={props.path} target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Voir le CV" : "View resume"}</a>
            <span style={{cursor:"pointer"}} onClick={props.removeCV}><img src='/img/x_noir.png' alt={i18n.language === "fr" ? "retirer" : "remove"}/></span>
        </ExistingCVContainer>
    )
};

export default MyProfile;